import * as Redux from 'redux';
import { PayersActionTypes, PayersState, PayerInfo,
  PayMethodsActionTypes, PayMethodsState, PayMethodsInfo,
  BillingEntity } from './billing.types';
import * as BILLING_ACTION_TYPES from './billing.const';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { initialPayersState, initialPayMethodsState } from './billing.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';
import { isUndefined } from 'util';

function replaceUndefinedPayer(payers: PayerInfo[]) {
  return !payers ? [] : payers;
}

function replaceUpdatedPayer(payers: PayerInfo[], updatedPayer: PayerInfo) { 
 return [updatedPayer, ...payers.filter((payer) => {
    return payer.id !== updatedPayer.id;
  })];
}

function replaceUndefinedPayMethod(payMethods: PayMethodsInfo[]) {
  return !payMethods ? [] : payMethods;
}

export const payersReducer: Redux.Reducer<PayersState> = 
  (payersState: PayersState = initialPayersState,
   action: ReduxAction<PayersActionTypes, SimpleResponse<BillingEntity>>): PayersState => {
  switch (action.type) {
    case `${BILLING_ACTION_TYPES.GET_PAYERS}_FULFILLED`:
      return { ...payersState,
        statusCode: action.payload.statusCode,
        payers: replaceUndefinedPayer(action.payload.body.list)
      };
    case `${BILLING_ACTION_TYPES.REGISTER_PAYER}_FULFILLED`:
      return { ...payersState,
        statusCode: action.payload.statusCode,
        newPayer: action.payload.body.entity, 
        payers: [action.payload.body.entity, ...payersState.payers]
      };
    case `${BILLING_ACTION_TYPES.UPDATE_PAYER}_FULFILLED`:
      return { ...payersState,
        statusCode: action.payload.statusCode,
        updatedPayer: action.payload.body.entity,
        payers: [...replaceUpdatedPayer(payersState.payers, action.payload.body.entity)]
      };
    case REVERT_TO_INITIAL_STATE:
      return initialPayersState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialPayersState;
    default:
      return payersState;
  }
};

export const payMethodsReducer: Redux.Reducer<PayMethodsState> = 
  (payMethodsState: PayMethodsState = initialPayMethodsState,
   action: ReduxAction<PayMethodsActionTypes, SimpleResponse<BillingEntity>>): PayMethodsState => {
  switch (action.type) {
    case `${BILLING_ACTION_TYPES.GET_PAYMETHODS}_FULFILLED`:
      return { ...payMethodsState,
        statusCode: action.payload.statusCode,
        payMethods: replaceUndefinedPayMethod(action.payload.body.list)
      };
    case `${BILLING_ACTION_TYPES.REGISTER_PAYMETHODS}_FULFILLED`:
      return { ...payMethodsState,
        statusCode: action.payload.statusCode,
        newPayMethod: action.payload.body.entity,
        payMethods: action.payload.statusCode === 200 ?
          [action.payload.body.entity, ...payMethodsState.payMethods] :
          [...payMethodsState.payMethods]
      };
    case `${BILLING_ACTION_TYPES.REMOVE_PAYMETHODS}_FULFILLED`:
      if (!isUndefined(action.meta)) {
        return { ...payMethodsState,
          statusCode: action.payload.statusCode,
          payMethods: action.payload.statusCode === 200 ?
            payMethodsState.payMethods.filter((payMethods: PayMethodsInfo) => {
              return payMethods.id !== action.meta!.id;
            }) :
            payMethodsState.payMethods
        };  
      } else {
        return payMethodsState;
      }
    case REVERT_TO_INITIAL_STATE:
      return initialPayMethodsState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialPayMethodsState;
    default:
      return payMethodsState;
  }
};


// WEBPACK FOOTER //
// ./src/billing/billing.reducer.tsx